import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/Tick-GIF.gif'


const _withScopeId = (n: any) => (_pushScopeId("data-v-314d2260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  "data-test": "sp-no-solo-title"
}
const _hoisted_3 = {
  key: 2,
  "data-test": "sp-same-plan-title"
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "yes", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Not sure? Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "cancel"),
  /*#__PURE__*/_createTextVNode(" and choose a different Strength.")
], -1))
const _hoisted_14 = {
  key: 2,
  "data-test": "sp-change-text"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "cancel", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/resources/read/dealing-with-obstacles-and-flagging-motivation",
  "data-test": "sp-resource-link"
}, "this resource", -1))
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Oops! It looks like you haven't completed a Solo review yet.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("The "),
  /*#__PURE__*/_createElementVNode("strong", null, "Personal Journey Pathway"),
  /*#__PURE__*/_createTextVNode(" will guide you to create a Solo report.")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Then you'll be ready to get the best from the Gyre Plans.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "Let's go"),
  /*#__PURE__*/_createTextVNode(" for the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Personal Journey Pathway.")
], -1))
const _hoisted_25 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 4,
  class: "text-center"
}
const _hoisted_27 = {
  key: 0,
  "data-test": "sp-same-plan-text"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 6 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Plan selected"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Good luck on your journey!")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 0,
  class: "controls center-flex"
}
const _hoisted_39 = {
  key: 1,
  class: "controls center-flex"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/Session/SoloReport",
  class: "btn btn-primary",
  "data-test": "sp-no-solo-btn"
}, " Let's go ", -1))
const _hoisted_41 = {
  key: 2,
  class: "controls center-flex"
}
const _hoisted_42 = {
  key: 3,
  class: "controls center-flex"
}
const _hoisted_43 = {
  key: 4,
  class: "controls center-flex"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary",
  disabled: "",
  type: "button"
}, "Continue", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 5,
  class: "controls center-flex"
}

import { computed, ref } from "vue";
import { Modal } from "uiv";
import axios from "axios";
import LoadingSpinner from "../loading-spinner.vue";

type DisplayVariant =
  | "first-plan"
  | "returning-to-this-plan"
  | "changing-plan"
  | "on-this-plan"
  | "not-completed-solo"
  | "set"
  | "in-progress";


export default /*#__PURE__*/_defineComponent({
  __name: 'strength-page-modal',
  props: {
    strengthData: {},
    currentDevelopPlan: {},
    isSoloCompleted: {},
    subscriptionLevel: {},
    otherProgress: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const shown = ref(false);
const inProgress = ref(false);
const isSet = ref(false);

const isThisPlanWasInProgressBefore = computed(() => {
  return props.otherProgress.some((e) => e.strengthItemId === props.strengthData.name);
});

const previousPlansProgress = computed(() => {
  if (isThisPlanWasInProgressBefore.value) {
    const data = props.otherProgress.filter((e) => e.strengthItemId === props.strengthData.name);
    return data[0].lastCompletedDayIndex;
  }
  return null;
});

const hasCompletedCurrentPlan = computed(() => {
  const totalDevelopDays = 25;
  return props.currentDevelopPlan.lastCompletedDayIndex === totalDevelopDays;
});

const displayMode = computed(() => {
  let displayVariant: DisplayVariant = "first-plan";

  if (props.isSoloCompleted === "Unlocked") {
    if (props.subscriptionLevel === "Full") {
      if (!props.currentDevelopPlan || hasCompletedCurrentPlan.value) {
        displayVariant = "first-plan";
        if (isSet.value) {
          displayVariant = "set";
          return displayVariant;
        }
        return displayVariant;
      }

      if (
        props.currentDevelopPlan.strengthItemId !== props.strengthData.name &&
        isThisPlanWasInProgressBefore.value
      ) {
        displayVariant = "returning-to-this-plan";
      } else {
        displayVariant = "changing-plan";
      }
      if (props.currentDevelopPlan.strengthItemId === props.strengthData.name) {
        displayVariant = "on-this-plan";
      }
    }
  } else {
    displayVariant = "not-completed-solo";
  }
  if (inProgress.value) {
    displayVariant = "in-progress";
  }
  if (isSet.value) {
    displayVariant = "set";
  }
  return displayVariant;
});

const backDropMode = computed(() => {
  return !(displayMode.value === "set" || displayMode.value === "in-progress");
});

const continueWithSelectedPlan = async () => {
  inProgress.value = true;
  const response = await axios.patch(
    `/api/engagequestionnaire/UpdateDevelop/${props.strengthData.name}`,
  );
  if (response.status === 200) {
    inProgress.value = false;
    isSet.value = true;
  }
};

const openModal = () => {
  shown.value = true;
};

const closeModal = () => {
  shown.value = false;
  inProgress.value = false;
};

__expose({
  openModal,
  closeModal,
});

// @Component({
//   components: { LoadingSpinner, Modal },
// })
// export default class StrengthPageModal extends Vue {
//   shown = false;

//   inProgress = false;

//   isSet = false;

//   displayVariant:
//     | "first-plan"
//     | "returning-to-this-plan"
//     | "changing-plan"
//     | "on-this-plan"
//     | "not-completed-solo"
//     | "set"
//     | "in-progress" = "first-plan";

//   @Prop()
//   strengthData;

//   @Prop()
//   currentDevelopPlan;

//   @Prop()
//   isSoloCompleted;

//   @Prop()
//   subscriptionLevel;

//   @Prop()
//   otherProgress;

//   get isThisPlanWasInProgressBefore(): boolean {
//     return this.otherProgress.some((e) => e.strengthItemId === this.strengthData.name);
//   }

//   get previousPlansProgress(): number | null {
//     if (this.isThisPlanWasInProgressBefore) {
//       const data = this.otherProgress.filter((e) => e.strengthItemId === this.strengthData.name);
//       return data[0].lastCompletedDayIndex;
//     }
//     return null;
//   }

//   get displayMode(): string {
//     // Check the user completed solo
//     if (this.isSoloCompleted === "Unlocked") {
//       // Check the account has full access
//       if (this.subscriptionLevel === "Full") {
//         if (!this.currentDevelopPlan || this.hasCompletedCurrentPlan) {
//           this.displayVariant = "first-plan";
//           if (this.isSet) {
//             this.displayVariant = "set";
//             return this.displayVariant;
//           }
//           return this.displayVariant;
//         }

//         if (
//           this.currentDevelopPlan.strengthItemId !== this.strengthData.name &&
//           this.isThisPlanWasInProgressBefore
//         ) {
//           this.displayVariant = "returning-to-this-plan";
//         } else {
//           this.displayVariant = "changing-plan";
//         }
//         if (this.currentDevelopPlan.strengthItemId === this.strengthData.name) {
//           this.displayVariant = "on-this-plan";
//         }
//       }
//     } else {
//       this.displayVariant = "not-completed-solo";
//     }
//     if (this.inProgress) {
//       this.displayVariant = "in-progress";
//     }
//     if (this.isSet) {
//       this.displayVariant = "set";
//     }
//     return this.displayVariant;
//   }

//   get backDropMode(): boolean {
//     return !(this.displayMode === "set" || this.displayMode === "in-progress");
//   }

//   async continueWithSelectedPlan(): Promise<void> {
//     this.inProgress = true;
//     const response = await axios.patch(
//       `/api/engagequestionnaire/UpdateDevelop/${this.strengthData.name}`,
//     );
//     if (response.status === 200) {
//       this.inProgress = false;
//       this.isSet = true;
//     }
//   }

//   get hasCompletedCurrentPlan(): boolean {
//     const totalDevelopDays = 25;
//     return this.currentDevelopPlan.lastCompletedDayIndex === totalDevelopDays;
//   }

//   openModal(): void {
//     this.shown = true;
//   }

//   closeModal(): void {
//     this.shown = false;
//     this.inProgress = false;
//   }
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shown).value = $event)),
    header: true,
    backdrop: backDropMode.value
  }, {
    title: _withCtx(() => [
      (
          displayMode.value === 'first-plan' ||
          displayMode.value === 'changing-plan' ||
          displayMode.value === 'returning-to-this-plan' ||
          displayMode.value === 'in-progress'
        )
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, " Develop " + _toDisplayString(_ctx.strengthData.name) + "? ", 1))
        : _createCommentVNode("", true),
      (displayMode.value === 'not-completed-solo')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, " Complete a Solo review "))
        : _createCommentVNode("", true),
      (displayMode.value === 'on-this-plan')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, " Continue developing " + _toDisplayString(_ctx.strengthData.name) + "? ", 1))
        : _createCommentVNode("", true),
      (displayMode.value === 'set')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.strengthData.name), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (displayMode.value === 'first-plan' || displayMode.value === 'changing-plan')
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: closeModal,
              "data-test": "sp-cancel",
              type: "button"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: continueWithSelectedPlan,
              "data-test": "sp-select-plan",
              type: "button"
            }, " Yes ")
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'not-completed-solo')
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: closeModal,
              type: "button"
            }, "Cancel"),
            _hoisted_40
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'on-this-plan')
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: closeModal,
              type: "button"
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/develop'))),
              type: "button"
            }, " Continue ")
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'returning-to-this-plan')
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: closeModal,
              type: "button"
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: continueWithSelectedPlan,
              type: "button"
            }, " Continue ")
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'in-progress')
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
        : _createCommentVNode("", true),
      (displayMode.value === 'set')
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/develop'))),
              "data-test": "spm-continue-btn",
              type: "button"
            }, " Continue ")
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (inProgress.value === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(LoadingSpinner),
            _hoisted_8,
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'first-plan' && !inProgress.value && !isSet.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", null, [
              _createTextVNode(" Are you ready to develop "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.strengthData.name) + "?", 1)
            ]),
            _hoisted_11,
            _createElementVNode("p", null, [
              _createTextVNode(" Click "),
              _hoisted_12,
              _createTextVNode(" and you'll be taken to the " + _toDisplayString(_ctx.strengthData.name) + " 25-day development plan. ", 1)
            ]),
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'changing-plan' && !inProgress.value && !isSet.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("p", null, [
              _createTextVNode(" Are you ready to develop "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.strengthData.name) + "?", 1),
              _createTextVNode(" This will replace your current development plan "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.currentDevelopPlan.strengthItemId) + ".", 1),
              _createTextVNode(" But don't worry! You can always pick up "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.currentDevelopPlan.strengthItemId), 1),
              _createTextVNode(" at a later date, exactly where you left off. ")
            ]),
            _hoisted_15,
            _createElementVNode("p", null, [
              _createTextVNode(" If you want to continue to develop "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.currentDevelopPlan.strengthItemId), 1),
              _createTextVNode(" click "),
              _hoisted_16,
              _createTextVNode(". We recommend "),
              _hoisted_17,
              _createTextVNode(" if you've fallen off the development wagon! ")
            ])
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'not-completed-solo')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_25))
        : _createCommentVNode("", true),
      (displayMode.value === 'on-this-plan')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            (_ctx.currentDevelopPlan.lastCompletedDayIndex < 25)
              ? (_openBlock(), _createElementBlock("p", _hoisted_27, " You are currently on day " + _toDisplayString(_ctx.currentDevelopPlan.lastCompletedDayIndex + 1) + " of 25. ", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_28, "You’ve already completed this develop plan."))
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'returning-to-this-plan' && !inProgress.value && !isSet.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("p", null, [
              _createTextVNode(" Are you ready to develop "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.strengthData.name) + "?", 1),
              _createTextVNode(" This will replace your current development plan "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.currentDevelopPlan.strengthItemId) + ".", 1),
              _createTextVNode(" But don't worry! You can always pick up " + _toDisplayString(_ctx.currentDevelopPlan.strengthItemId) + " at a later date, exactly where you left off. ", 1)
            ]),
            _hoisted_30,
            (previousPlansProgress.value && previousPlansProgress.value < 25)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                  _createTextVNode(" It looks like you're already on day " + _toDisplayString(previousPlansProgress.value + 1) + " of ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.strengthData.name) + ".", 1)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_32, "You’ve already completed this develop plan."))
          ]))
        : _createCommentVNode("", true),
      (displayMode.value === 'set')
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_37))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "backdrop"]))
}
}

})